import Provider from '@classes/Provider'

const api = new Provider({
  baseURL: '/json',
  withCredentials: false,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

Provider.prototype.getRoutes = function (params) {
  const url = `/routes.json`
  return this.getJSON(url, params)
}

Provider.prototype.getTranslations = function (params) {
  const url = `/translations.json`
  return this.getJSON(url, params)
}

Provider.prototype.getCommonContent = function (params) {
  const url = `/${window.AppSettings.language}/main/common.json`
  return this.getJSON(url, params)
}

Provider.prototype.getPageContent = function (name, params) {
  const url = `/${window.AppSettings.language}/main/${name}.json`
  return this.getJSON(url, params)
}

Provider.prototype.getWorkPageContent = function (name, params) {
  const url = `/${window.AppSettings.language}/works/${name}.json`
  return this.getJSON(url, params)
}

export default api
